/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetBroadcastsQueryResponse, YoutubeIntegrationGetBroadcastsPathParams, YoutubeIntegrationGetBroadcastsQueryParams, YoutubeIntegrationGetBroadcasts401, YoutubeIntegrationGetBroadcasts403 } from "../models/YoutubeIntegrationGetBroadcasts";

export function getYoutubeIntegrationGetBroadcastsUrl(station: YoutubeIntegrationGetBroadcastsPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-integration/v1/broadcasts/${station}` as const }
  return res
}

/**
 * @description Computes on-air intervals from stream gaps in the requested window, matches live/ended YouTube videos for the station channel, and returns enriched broadcast rows sorted most-recent first.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-integration/v1/broadcasts/:station}
 */
export async function youtubeIntegrationGetBroadcasts(station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YoutubeIntegrationGetBroadcastsQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>, unknown>({ method : "GET", url : getYoutubeIntegrationGetBroadcastsUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}